module.exports = __webpack_public_path__ + "static/qlik-sense-1x-6d172c1ad525578de09842761118fc84.png";